export enum SurveyStatusFlag {
    None,
    Created = 1,
    InProgress = 2,
    Completed = 4,
    Failed = 8,
}
